import { SIcon } from '@avalara/skylab-sdk/react';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { completePlanSelect } from '../../../../lib/side-effects/offer-flow';
import { offerStateSelector } from '../../../../selectors/offer';
const NextButton = ({ selectedPlanName, disableButton }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { offerFlow, plans } = useSelector(offerStateSelector);
    const selectedPlan = plans.find(plan => plan.name === selectedPlanName);
    return React.createElement("button", { className: 'primary icon-trailing', disabled: !selectedPlanName || disableButton, onClick: selectedPlan ? () => dispatch(completePlanSelect(selectedPlan, { history })) : undefined, "data-ref": offerFlow ? `${offerFlow}.plan-select-button` : '' },
        "Next ",
        React.createElement(SIcon, { name: 'arrow-circle-right' }));
};
export default NextButton;
